import { useState } from "@faire/web--source/ui/hooks/useState";
import { useCallback } from "react";

type AsyncDataStatus = "not-requested-yet" | "in-progress" | "complete";

export const useAsyncDataStatus = () => {
  const [status, setStatus] = useState<AsyncDataStatus>("not-requested-yet");

  const setAsInProgress = useCallback(() => setStatus("in-progress"), []);
  const setAsComplete = useCallback(() => setStatus("complete"), []);
  const setAsNotRequestedYet = useCallback(
    () => setStatus("not-requested-yet"),
    []
  );

  const asyncDataInProgress = status === "in-progress";
  const asyncDataComplete = status === "complete";

  return {
    asyncDataInProgress,
    asyncDataComplete,
    setAsInProgress,
    setAsComplete,
    setAsNotRequestedYet,
  };
};
